/**
 * @generated SignedSource<<bc521d21078c8563da23be62d5dbd4a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdminListAccountsRequest = {
  includeArchived?: boolean | null;
  pageNumber?: number | null;
  pageSize?: number | null;
  search?: string | null;
};
export type AccountsTabQuery$variables = {
  input: AdminListAccountsRequest;
};
export type AccountsTabQuery$data = {
  readonly adminListAccounts: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly brandCount: number;
      readonly createdAt: any;
      readonly featureFlagIds: ReadonlyArray<string>;
      readonly id: string;
      readonly metaBusinessAccountId: string;
      readonly name: string;
      readonly owner: {
        readonly email: string | null;
        readonly fullName: string | null;
        readonly id: string;
      } | null;
      readonly ownerId: string | null;
      readonly userCount: number;
    }>;
  };
};
export type AccountsTabQuery = {
  response: AccountsTabQuery$data;
  variables: AccountsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminAccountList",
    "kind": "LinkedField",
    "name": "adminListAccounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminAccount",
        "kind": "LinkedField",
        "name": "data",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaBusinessAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brandCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ownerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlagIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AdminUserRef",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountsTabQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountsTabQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "47742e9a8a1af4a4d2748a70df17d5e4",
    "id": null,
    "metadata": {},
    "name": "AccountsTabQuery",
    "operationKind": "query",
    "text": "query AccountsTabQuery(\n  $input: AdminListAccountsRequest!\n) {\n  adminListAccounts(input: $input) {\n    count\n    data {\n      id\n      name\n      metaBusinessAccountId\n      createdAt\n      userCount\n      brandCount\n      ownerId\n      featureFlagIds\n      owner {\n        id\n        email\n        fullName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "75ceb34128201849ef8356c1c99b3e73";

export default node;
